import api from '../../../../../api/client';
import { AUCTION, PAYMENT } from '../../../../../api/endpoints';
import { handleApiResponse } from '../../../../../api/handlers';

export async function fetchAcknowledgementPdf(auctionId, lang = 'en', enrollId = null) {
  try {
    const response = await api.get(AUCTION.ACKNOWLEDGEMENT_VIEW(auctionId), {
      params: { enrollId: enrollId, lang },
      responseType: 'blob',
    });
    return handleApiResponse(response);
  } catch (error) {
    const err = new Error(error.response?.data?.message || 'Failed to load acknowledgement PDF');
    err.response = error.response;
    err.status = error.response?.status || 500;
    throw err;
  }
}

export async function scanReceipt(formData) {
  try {
    const response = await api.post(PAYMENT.RECEIPT_SCAN, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return handleApiResponse(response);
  } catch (error) {
    const err = new Error(error.response?.data?.message || 'Failed to scan receipt');
    err.response = error.response;
    err.status = error.response?.status || 500;
    throw err;
  }
}

export async function userEnrollment(formData) {
  try {
    const response = await api.post(AUCTION.ENROLL, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return handleApiResponse(response);
  } catch (error) {
    const err = new Error(error.response?.data?.message || 'Failed to scan receipt');
    err.response = error.response;
    err.status = error.response?.status || 500;
    throw err;
  }
}
